import fetcher from 'api/fetcher';
import axios, { AxiosError, Canceler } from 'axios';
import { MagritteNotificationName } from 'utils/constants/notification';

import urlParser from 'bloko/common/urlParser';

import type { BidRating } from 'store/models/auctionData';
import { AuctionBuilderErrors, setErrors } from 'store/models/auctionData';
import {
    selectMultiCreationVacanciesAuctionInfo,
    setMultiCreationBidFrequencyStatus,
} from 'store/models/multiCreation';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

type FetchMultiCreationBidRating = (props: { vacancyId: number; bid: string }) => AppThunkAction;

let cancelPreviousRequest: Canceler | undefined;

export const fetchMultiCreationBidRating: FetchMultiCreationBidRating = ({ vacancyId, bid }) => {
    return (dispatch, getState) => {
        const bidRatingParams = selectMultiCreationVacanciesAuctionInfo(getState())[vacancyId].bidRatingParams;

        cancelPreviousRequest?.();
        const source = axios.CancelToken.source();
        cancelPreviousRequest = source.cancel;

        const query = urlParser.stringify({
            bid,
            ...bidRatingParams,
            areaIds: bidRatingParams.areaIds?.map(String),
            professionalRoleIds: bidRatingParams.professionalRoleIds?.map(String),
        });
        return fetcher
            .get<unknown, BidRating>(`/api/v1/auction/bid_rating?${query}`, {
                cancelToken: source.token,
            })
            .then(({ bidFrequencyStatus }) => {
                dispatch(setMultiCreationBidFrequencyStatus({ vacancyId, bidFrequencyStatus }));
            })
            .catch((error: AxiosError<AuctionBuilderErrors>) => {
                if (axios.isCancel(error)) {
                    return;
                }
                if (error?.response?.status === 400) {
                    const errors = error.response.data;
                    dispatch(setErrors(errors));
                } else {
                    dispatch(addMagritteNotification(MagritteNotificationName.AuctionBuilderSomethingWentWrongError));
                }
            });
    };
};
